import React from 'react';
import { classCombine } from 'Utils/Utils';
import './PageTitle.css';

const PageTitle = ({ text, alignText = 'left', modernLayout, customClass = '' }) => {
  return (
    <div className={`pageTitleContainer ${modernLayout && 'modernLayout'}`}>
      <h1 className={classCombine('pageTitle', alignText, customClass)}>{text}</h1>
    </div>
  );
};

export default PageTitle;
